import React, { useState, useEffect } from "react";
import { notification } from "antd";
import axios from "axios";
import { Console } from "console";


export const useForm = (validate: any) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [shouldSubmit, setShouldSubmit] = useState(false);

  const openNotificationWithIcon = () => {
    notification["success"]({
      message: "Success",
      description: "Your message has been sent!",
    });
  };
  

  useEffect(() => {
    if (Object.keys(errors).length === 0 && shouldSubmit) {
      setValues("");
      openNotificationWithIcon();
    }
  }, [errors, shouldSubmit]);

  const handleSubmit = (event:any) => {
    event.preventDefault();
    setErrors(validate(values));
    // Your url for API
    const url = ""; 
    if (Object.keys(values).length === 3) {
      axios
        .post(url, {
          ...values,
        })
        .then(() => {
          setShouldSubmit(true);
        });
    }
  };

  const handleChange = (event:any) => {
    console.log(event);
    console.log(event.target.name);
    console.log(event.target.value);

    event.persist();

    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
    setErrors((errors) => ({ ...errors, [event.target.name]: "" }));
  };

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
    setErrors,
    setValues,
    validate,
  };
};
